import { createSlice } from "@reduxjs/toolkit";
import {
  getCustomerRecords,
  getPaymentHistory,
  getOrderHistory,
  getBalanceHistory,
  shareBalanceSheet,
} from "../thunks/customerRecordThunk";

const initialState = {
  isCustmerLoading: false,
  pagination: {
    current_page: 1,
    total_pages: 1,
    total_records: 0,
  },
};

const customerRecordSlice = createSlice({
  name: "customerRecords",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerRecords.pending, (state) => {
        state.isCustmerLoading = true;
      })
      .addCase(getCustomerRecords.fulfilled, (state, action) => {
        state.isCustmerLoading = false;
        state.action = action.payload;
      })
      .addCase(getCustomerRecords.rejected, (state) => {
        state.isCustmerLoading = false;
      })
      .addCase(getPaymentHistory.pending, (state) => {
        state.isCustmerLoading = true;
      })
      .addCase(getPaymentHistory.fulfilled, (state, action) => {
        state.isCustmerLoading = false;
        state.action = action.payload;
        const data = action.payload.data;
        ((state.pagination.current_page = data.current_page),
          (state.pagination.total_pages = data.total_pages),
          (state.pagination.total_records = data.total_records));
      })
      .addCase(getPaymentHistory.rejected, (state) => {
        state.isCustmerLoading = false;
      })
      .addCase(getOrderHistory.pending, (state) => {
        state.isCustmerLoading = true;
      })
      .addCase(getOrderHistory.fulfilled, (state, action) => {
        ((state.isCustmerLoading = false), (state.action = action.payload));
        const data = action.payload.data;
        ((state.pagination.current_page = data.current_page),
          (state.pagination.total_pages = data.total_pages),
          (state.pagination.total_records = data.total_records));
      })
      .addCase(getOrderHistory.rejected, (state) => {
        state.isCustmerLoading = false;
      })
      .addCase(getBalanceHistory.pending, (state) => {
        state.isCustmerLoading = true;
      })
      .addCase(getBalanceHistory.fulfilled, (state, action) => {
        state.isCustmerLoading = false;
        state.action = action.payload;
        const data = action.payload.data;
        ((state.pagination.current_page = data.current_page),
          (state.pagination.total_pages = data.total_pages),
          (state.pagination.total_records = data.total_records));
      })

      .addCase(getBalanceHistory.rejected, (state) => {
        state.isCustmerLoading = false;
      })

      .addCase(shareBalanceSheet.pending, (state) => {
        state.isCustmerLoading = true;
      })
      .addCase(shareBalanceSheet.fulfilled, (state, action) => {
        ((state.isCustmerLoading = false), (state.action = action.payload));
      })
      .addCase(shareBalanceSheet.rejected, (state) => {
        state.isCustmerLoading = false;
      });
  },
});

export default customerRecordSlice.reducer;
